import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { CaretDown } from '../icons';

export const TrustTypePicker = ({
  selectedKey,
  onChange,
  required,
  className,
  style,
  errorMessage,
  label,
}) => (
  <Dropdown
    onRenderCaretDown={() => <CaretDown />}
    selectedKey={selectedKey}
    className={className}
    onChange={onChange}
    required={required}
    style={style}
    errorMessage={errorMessage}
    label={label}
    options={[
      { key: 'Y', text: 'Yes' },
      { key: 'N', text: 'No' },
    ]}
  />
);

TrustTypePicker.propTypes = {
  selectedKey: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
};

TrustTypePicker.defaultProps = {
  selectedKey: { key: 0 },
  required: false,
  className: '',
  style: {},
  errorMessage: '',
  label: 'Is Living Or Revokable Trust',
};

export default TrustTypePicker;
